import {Component, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {Global} from "../global";
import {Location} from '@angular/common';
import {CertificadosNacionaisService} from './certificados-nacionais.service';
import {Funcoes} from '../funcoes';
import {CertificadosNacionaisModel} from './certificados-nacionais.model';

@Component({
  selector: 'app-pdf-certificado-nacional',
  templateUrl: './pdf-certificado-nacional.component.html'
})
export class PdfCertificadoNacionalComponent implements OnInit {

  urlCertificado = '';
  urlLaudo = '';
  title = 'Arquivos do Certificado';

  certificado: any = new CertificadosNacionaisModel();

  alturaTela;

  constructor(
    public global: Global,
    private route: ActivatedRoute,
    private _location: Location,
    public func: Funcoes,
    private certificadosService: CertificadosNacionaisService
  ) {
    this.alturaTela = window.screen.availHeight - 250;
  }

  ngOnInit() {
    let id_certificado = this.route.snapshot.params['id_certificado'] ||
      (this.route.parent ? this.route.parent.snapshot.params['id_certificado'] : null);

    if (id_certificado) {
      this.carregarDados(id_certificado);
    } else {
      this.route.params.subscribe(params => {
        let id = params['id_certificado'] || (this.route.parent ? this.route.parent.snapshot.params['id_certificado'] : null);
        if (id) {
          this.carregarDados(id);
        }
      });
    }
  }

  carregarDados(id_certificado) {
    this.urlCertificado = this.global.dominio_site + '/adm/certificados-nacionais/' + id_certificado + '/pdf/?tk=' + localStorage.getItem('token');
    this.urlLaudo = this.global.dominio_site + '/adm/certificados-nacionais/' + id_certificado + '/pdf-laudo/?tk=' + localStorage.getItem('token');

    this.certificadosService.getById(id_certificado, ["mercadoria_full"])
      .subscribe(
        json => {
          if (json && json.Payload && json.Payload.length > 0) {
            this.certificado = json.Payload[0];
          }
        },
        error => {
          if (error && typeof error.json === 'function') {
            this.func.showErro(error.json());
          }
        });
  }

  voltar() {
    this._location.back();
  }

}



// WEBPACK FOOTER //
// ./src/app/certificados-nacionais/pdf-certificado-nacional.component.ts